import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getJson } from '@hcr/api/shared'

import type { ProblemDetailsDto, UserDetailsDto } from '../../dtos'
import { UserDetailsDtoSchema } from '../../dtos'

interface UserEmailChangeConfirmationQueryParams {
  nonce: string
}

export const createUserEmailChangeConfirmationQueryKey = (params: UserEmailChangeConfirmationQueryParams) => [
  'consumer',
  'onboarding',
  params,
]

export const createUserEmailChangeConfirmationQuery =
  (baseUrl: string) =>
  <Data = UserDetailsDto>(
    params: UserEmailChangeConfirmationQueryParams,
    options?: Partial<UseQueryOptions<UserDetailsDto, ProblemDetailsDto, Data>>
  ) =>
    useQuery<UserDetailsDto, ProblemDetailsDto, Data>({
      ...options,
      queryKey: createUserEmailChangeConfirmationQueryKey(params),
      queryFn: () =>
        getJson({
          schema: UserDetailsDtoSchema,
          url: `${baseUrl}/user/email/change-confirmation/${params.nonce}`,
        }),
    })
